module.exports = __webpack_public_path__ + "img/seoyoung.ca4c69be.png";